import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function FeedbackPage() {
  const [text, setText] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const { data } = await api.get('/feedback');
      setItems(data);
    } catch { }
    setLoading(false);
  };

  const submit = async () => {
    if (!text.trim() || submitting) return;
    setSubmitting(true);
    setError('');
    setSuccess('');
    try {
      await api.post('/feedback', { text: text.trim() });
      setText('');
      setSuccess('Thank you for your feedback.');
      load();
      setTimeout(() => setSuccess(''), 4000);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to submit. Please try again.');
    }
    setSubmitting(false);
  };

  const fmtDate = (d) => new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  return (
    <div style={s.page}>
      <div style={s.card}>
        <h1 style={s.h1}>Feedback</h1>
        <p style={s.desc}>
          Share your feedback about the app, its features, or suggestions for improvement. This is not a support portal — it is a space for you to help us make AskNitin better. All feedback is reviewed for app improvements.
        </p>

        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Write your feedback here..."
          rows={5}
          maxLength={5000}
          style={s.textarea}
        />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
          <span style={{ fontSize: 11, color: '#9ca3af' }}>{text.length} / 5000</span>
          <button
            onClick={submit}
            disabled={!text.trim() || submitting}
            style={{ ...s.btn, opacity: !text.trim() || submitting ? 0.45 : 1 }}
          >
            {submitting ? 'Submitting...' : 'Submit Feedback'}
          </button>
        </div>

        {success && <div style={s.success}>{success}</div>}
        {error && <div style={s.error}>{error}</div>}
      </div>

      {/* Past feedback */}
      {!loading && items.length > 0 && (
        <div style={s.card}>
          <h2 style={s.h2}>Your Past Feedback</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {items.map(fb => (
              <div key={fb._id} style={s.fbItem}>
                <p style={s.fbText}>{fb.text}</p>
                <p style={s.fbDate}>{fmtDate(fb.createdAt)}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { maxWidth: '640px', margin: '0 auto', padding: '32px 18px 60px', display: 'flex', flexDirection: 'column', gap: 16 },
  card: { background: '#fff', borderRadius: 16, border: '1px solid #e2e8f0', padding: '24px 22px', boxShadow: '0 2px 12px rgba(12,35,64,0.05)' },
  h1: { fontFamily: "'DM Sans',sans-serif", fontSize: 24, fontWeight: 800, color: '#0c2340', margin: '0 0 8px' },
  h2: { fontFamily: "'DM Sans',sans-serif", fontSize: 17, fontWeight: 700, color: '#0c2340', margin: '0 0 12px' },
  desc: { fontSize: 13, color: '#6b7280', lineHeight: 1.7, margin: '0 0 16px' },
  textarea: {
    width: '100%', padding: '12px 14px', borderRadius: 12,
    border: '1.5px solid #d1d5db', fontSize: 14,
    fontFamily: "'DM Sans',sans-serif", resize: 'vertical',
    outline: 'none', boxSizing: 'border-box', lineHeight: 1.6,
    minHeight: 100,
  },
  btn: {
    background: '#0c2340', color: '#fff', border: 'none',
    padding: '10px 22px', borderRadius: 10, fontSize: 13,
    fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Sans',sans-serif",
  },
  success: { fontSize: 13, color: '#065f46', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '10px 14px', marginTop: 10 },
  error: { fontSize: 13, color: '#991b1b', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '10px 14px', marginTop: 10 },
  fbItem: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 16px' },
  fbText: { fontSize: 13, color: '#1e293b', lineHeight: 1.7, margin: 0, whiteSpace: 'pre-wrap' },
  fbDate: { fontSize: 11, color: '#9ca3af', margin: '8px 0 0' },
};
